import { Box } from '@chakra-ui/react';
import { useTranslations } from '@ui/i18n';
import React from 'react';

function DistributionExplainer() {
  const t = useTranslations();
  return (
    <Box px={{ base: 0, desktop: 8 }} py={{ base: 0, desktop: 4 }}>
      {t('vno-distribution-desc')}
    </Box>
  );
}

export default DistributionExplainer;
